'use client';

import { motion } from 'framer-motion';

export const MotionSpan = motion.span;
